(function () {
  var root = document.querySelector('[data-design-scroll]');
  if (!root) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return; /* stays a plain swipeable strip */

  root.classList.add('is-animated');

  var button = root.querySelector('[data-design-scroll-toggle]');
  if (!button) return;
  button.hidden = false;
  button.addEventListener('click', function () {
    var paused = root.classList.toggle('is-paused');
    button.textContent = paused ? 'Play' : 'Pause';
    button.setAttribute('aria-label', paused ? 'Play the nail design scroll' : 'Pause the nail design scroll');
  });
})();
